import { useEffect } from 'react';
import { useGetUserInformationQuery } from 'src/graphql/generated/graphql';
import logger from 'src/utils/logger';
import { useAppDispatch } from 'src/store/hooks';
import usePageLoaded from 'src/hooks/usePageLoaded';
import { updateUserInformation } from '../slices/userInformationSlice';

const useGetUserInformation = () => {
  const dispatch = useAppDispatch();
  const pageLoaded = usePageLoaded();

  const { data, error, isError, isSuccess, isLoading } = useGetUserInformationQuery(
    {},
    {
      cacheTime: Infinity,
      staleTime: Infinity,
      retry: false,
      select: (queryResponse) => queryResponse.getUserInformation,
      enabled: pageLoaded,
    },
  );

  const { alias, allowedStyleMerchLocationGroup, error: userInformationError } = data ?? {};

  useEffect(() => {
    if (isError) {
      const { message, name } = error as Error;
      void logger.error(`Error occured while retriving user information: ${name}, ${message}`);
    }
  }, [isError, error]);

  useEffect(() => {
    if (isError) {
      const { errorMessage, errorType } = userInformationError ?? {};
      void logger.error(`Error occured while retriving user information: ${errorType}, ${errorMessage}`);
    }
  }, [isError, error, userInformationError]);

  useEffect(() => {
    if (alias) {
      dispatch(
        updateUserInformation({
          alias,
          allowedStyleMerchLocationGroup,
        }),
      );
    }
  }, [dispatch, alias, allowedStyleMerchLocationGroup]);

  return {
    alias,
    allowedStyleMerchLocationGroup,
    isError,
    isSuccess,
    isLoading,
  };
};

export default useGetUserInformation;
